export default "__VITE_ASSET__Y_ABnh$x__"